import React from 'react';
import { Text, View } from 'react-native';
import i18n from 'i18n-js';

import { font } from '@styles/fonts';
import { convertSecondsToObject } from '@v2/helpers/time';

export default ({
  seconds,
  C,
  name,
  left,
  bottomPopupWidth,
  zIndex,
  averageColor,
}: {
  seconds: number;
  left: number;
  zIndex: number;
  bottomPopupWidth: number;
  C: (color: string) => string;
  name: string;
  averageColor: string;
}) => {
  const time = convertSecondsToObject(seconds, false, false, true);
  const isDays = Number(time.d) > 0;
  const isHours = Number(time.h) > 0;

  return (
    <View
      style={{
        alignItems: 'center',
        justifyContent: 'center',
        position: 'absolute',
        width: bottomPopupWidth,
        left,
        zIndex,
        top: 12,
      }}
    >
      <View style={{ alignItems: 'center', width: '100%' }}>
        <View style={{ width: 1, height: 6, backgroundColor: C(averageColor), position: 'absolute', left: bottomPopupWidth / 2 }} />
        <View style={{ width: 1, height: 6 }} />
        <Text style={[font['Subhead 2'], { color: C(averageColor) }]}>{i18n.t(name)}</Text>
        <View
          style={{
            paddingHorizontal: 6,
            paddingVertical: 4,
            flexDirection: 'row',
            marginTop: 1,
            width: '100%',
            justifyContent: 'center',
          }}
        >
          <Text numberOfLines={1}>
            {isDays && (
              <Text style={[font['Headline'], { color: C(averageColor) }]}>
                {Number(time.d)}
                {i18n.t('d')}{' '}
              </Text>
            )}
            <Text style={[font['Headline'], { color: C(averageColor) }]}>
              {Number(isDays ? time.h : isHours ? time.h : time.m)}
              {i18n.t(isDays ? 'h' : isHours ? 'h' : 'm')}{' '}
            </Text>
            {!isDays && (
              <Text style={[font['Headline'], { color: C(averageColor) }]}>
                {Number(isDays ? time.m : isHours ? time.m : time.s)}
                {i18n.t(isDays ? 'm' : isHours ? 'm' : 's')}
              </Text>
            )}
          </Text>
        </View>
      </View>
    </View>
  );
};
